module.exports = __webpack_public_path__ + "img/tutorial_simulated_05.11f1b5c7.gif";